import ReactDOM from "react-dom";
import React, { Component, useEffect, useState } from "react";
import { component } from "picoapp";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useQueryClient,
} from "react-query";
import axios from "axios";

import { questionsArray, results } from "./API";
import Questions from "./Questions";
import AssessmentResults from "./AssessmentResults";
import Sugestions from "./Sugestions";

import LoadingSpinner from "../../parts/LoadingSpinner";

import "./style.scss";

const queryClient = new QueryClient();

const QuizWrapper = ({ appstate, node }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Quiz appstate={appstate} node={node} />
    </QueryClientProvider>
  );
};

const Quiz = ({ appstate, node }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [questions, setQuestions] = useState(questionsArray);
  const [answers, setAnswers] = useState({});
  const [recomendations, setRecomendations] = useState(null);
  const [hasRecomendations, setHasRecomendations] = useState(false);
  const [assessmentCompleted, setAssessmentCompleted] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleSelection = (e) => {
    if (e.target.name == "plan") {
      const value =
        e.target.value == "Mostly Down"
          ? e.target.value
          : e.target.value.split(", ");
      const has_multiple = value == "Mostly Down" ? false : true;
      const plan = answers.plan ? [...answers.plan] : [];

      if (!has_multiple) {
        if (e.target.checked && !plan.includes(value)) {
          plan.push(value);
        } else if (!e.target.checked && plan.includes(value)) {
          plan.splice(plan.indexOf(value), 1);
        }
      } else {
        if (e.target.checked && !value.every((o) => plan.includes(o))) {
          plan.push(...value);
        } else if (!e.target.checked && value.every((o) => plan.includes(o))) {
          value.forEach((v) => plan.splice(plan.indexOf(v), 1));
        }
      }

      setAnswers({ ...answers, plan: plan });
    } else if (
      e.target.name == "goals" &&
      e.target.value == "Volume & Length"
    ) {
      //VOLUME & LENGTH SHOWS SAME RESULTS AS JUST LENGTH
      setAnswers({ ...answers, goals: "Length" });
    } else {
      setAnswers({ ...answers, [e.target.name]: e.target.value });
    }
  };

  const fetchProducts = async (handles) => {
    const products = [];
    for (let handle of handles) {
      const { data } = await axios.get(`/products/${handle}.js`, {
        headers: { Pragma: "no-cache" },
      });
      products.push(data);
    }

    setRecomendations(products);
    setAssessmentCompleted(true);
  };

  const handleResults = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setIsLoading(true);
    const productHandles = [];
    const flatAnswers = Object.values(answers).flat();
    results.forEach((r) => {
      r.possibleAnswers.forEach((p) => {
        if (p.every((p) => flatAnswers.includes(p))) {
          productHandles.push(r.productHandle);
        }
      });
    });
    const uniqueHandles = [...new Set(productHandles)];

    fetchProducts(uniqueHandles);

    //GA QUIZ TRACKING
    ga("set", "dimension1", answers["hair-type"]);
    ga("set", "dimension2", answers["thickness"]);
    ga("set", "dimension3", answers["length"]);
    ga("set", "dimension4", answers["goals"]);
    ga("set", "dimension5", answers["plan"]);
    ga("send", "event", "Quiz", "Completed", "Quiz Page");
  };
  useEffect(() => {
    if (assessmentCompleted) {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [assessmentCompleted]);

  useEffect(() => {
    if (recomendations?.length) {
      setHasRecomendations(true);
    }
  }, [recomendations]);

  const resetQuiz = () => {
    setAnswers({});
    setRecomendations(null);
    setAssessmentCompleted(false);
    window.scrollTo(0, 0);
  };

  if (isLoading) {
    return (
      <div className="Main__header Container">
        <LoadingSpinner></LoadingSpinner>
      </div>
    );
  }

  return (
    <>
      <div className="Main__header Container">
        <h1 className="heading">
          {!hasRecomendations && <p>Get Expert Advice</p>}
          {assessmentCompleted && hasRecomendations && (
            <p>
              Your expert <b>recommended</b> product!
            </p>
          )}
        </h1>
      </div>
      <div className="Main__content Container">
        {!assessmentCompleted ? (
          <Questions questions={questions} handleSelection={handleSelection} />
        ) : (
          <>
            {/* <AssessmentResults answers={answers} /> */}
            {hasRecomendations ? (
              <Sugestions products={recomendations} />
            ) : (
              <div className="Section Section--noResults">
                <div className="Section__header">
                  <h4 className="heading"> No matches found</h4>
                </div>
                <div className="Section__content">
                  <button
                    type="Button"
                    className="Button"
                    data-style="solid pink"
                    onClick={resetQuiz}
                  >
                    Restart Quiz
                  </button>
                </div>
              </div>
            )}
          </>
        )}
        {!assessmentCompleted &&
          Object.keys(answers).length == 5 &&
          answers.plan.length > 0 && (
            <div className="Quiz-cta">
              <button
                type="button"
                className="Button"
                data-style="solid pink"
                onClick={handleResults}
              >
                See Results
              </button>
            </div>
          )}
        {assessmentCompleted && (
          <div class="Product__cmk-cta Media">
            <figure class="Media__content">
              <img
                src="https://cdn.shopify.com/s/files/1/1331/4649/files/cmk_triple.png?v=1632988716"
                // srcset="
                //     {{ image | img_url: '100x' }} 10w"
                sizes="auto"
                lazyload="lazy"
                width="50px"
                height="50px"
                alt="Color Match Kit"
              />
            </figure>
            <div>
              <p>
                Not sure which color to get? Try our{" "}
                <a href="/collections/color-match-kit" title="Color Match Kit">
                  Color match kit
                </a>
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default component((node, ctx) => {
  const element = <QuizWrapper appstate={ctx} node={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
